"use strict";
/**
 * Orderbook Utilities
 * Helper functions for orderbook data processing
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBidsAndAsks = getBidsAndAsks;
/**
 * Extract bid/ask prices from orderbook data
 * @param orderbook - Orderbook data
 * @returns Bid and ask prices for yes and no sides
 */
function getBidsAndAsks(orderbook) {
    const sortedYesBids = orderbook.yes_dollars.sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))[0];
    const sortedNoBids = orderbook.no_dollars.sort((a, b) => parseFloat(b[0]) - parseFloat(a[0]))[0];
    const yesBidPrice = parseFloat(sortedYesBids[0]);
    const noBidPrice = parseFloat(sortedNoBids[0]);
    const yesAskPrice = 1.0 - noBidPrice;
    const noAskPrice = 1.0 - yesBidPrice;
    return {
        yes_bid: yesBidPrice,
        yes_ask: yesAskPrice,
        no_bid: noBidPrice,
        no_ask: noAskPrice,
    };
}
